import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { userInfoState } from '../../HomePage/HomeSlice';

export default function GeneralWagonDetails(props) {
  const {
    wagonTechnicalDetails,
    wagonStatus,
    classes,
    expanded,
    handleChange,
  } = props;
  const [wagonTechnicalDetailsState, setWagonTechnicalDetailsState] =
    React.useState(null);
  const [wagonStatusState, setWagonStatusState] = React.useState('');
  useEffect(() => {
    if (wagonTechnicalDetails !== undefined) {
      setWagonTechnicalDetailsState(wagonTechnicalDetails);
    }
    setWagonStatusState(wagonStatus);
  }, [wagonTechnicalDetails, wagonStatus]);
  const user = useSelector(userInfoState);
  const dateFormatter = (date) => {
    return new Intl.DateTimeFormat('en-GB').format(new Date(date));
  };
  const { t } = useTranslation();

  return (
    <div>
      {wagonTechnicalDetailsState && (
        <Accordion
          className={classes.accordion}
          expanded={expanded}
          onChange={handleChange}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
          >
            <Typography className={classes.heading}>
              {t('General wagon details')}
            </Typography>
            <Typography className={classes.secondaryHeading}>
              {t('Find here the main wagon details')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.container}>
              {user.hasAllRights &&
              wagonTechnicalDetailsState.deletedFromFleet ? (
                <Grid container spacing={1} className={classes.gridMargin}>
                  <Grid item xs={3}>
                    <FormLabel className={classes.formLabel}>
                      {t('Wagon number')}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={3}>
                    <FormLabel className={classes.formLabel}>
                      {t('Keeper')}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={2}>
                    <FormLabel className={classes.formLabel}>
                      {' '}
                      {t('Product')}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={2}>
                    <FormLabel className={classes.formLabel}>
                      {' '}
                      {t('Status')}{' '}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={2}>
                    <FormLabel className={classes.formLabel}>
                      {t('Deletion date')}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={3}>
                    <FormLabel className={classes.wagonNumberStyle}>
                      {wagonTechnicalDetailsState.wagonNumber}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={3}>
                    <FormLabel className={classes.wagonDetail}>
                      {wagonTechnicalDetailsState.keeper !== null &&
                      wagonTechnicalDetailsState.keeper !== ''
                        ? wagonTechnicalDetailsState.keeper
                        : '-'}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={2}>
                    <FormLabel className={classes.wagonDetail}>
                      {wagonTechnicalDetailsState.productType !== null &&
                      wagonTechnicalDetailsState.productType !== ''
                        ? wagonTechnicalDetailsState.productType
                        : '-'}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={2}>
                    <FormLabel className={classes.deletedStatusStyle}>
                      {t(wagonStatusState)}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={2}>
                    <FormLabel className={classes.wagonDetail}>
                      {dateFormatter(wagonTechnicalDetailsState.deletionDate)}
                    </FormLabel>
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={1} className={classes.gridMargin}>
                  <Grid item xs={3}>
                    <FormLabel className={classes.formLabel}>
                      {t('Wagon number')}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={3}>
                    <FormLabel className={classes.formLabel}>
                      {t('Keeper')}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={3}>
                    <FormLabel className={classes.formLabel}>
                      {' '}
                      {t('Product')}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={3}>
                    <FormLabel className={classes.formLabel}>
                      {' '}
                      {t('Status')}{' '}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={3}>
                    <FormLabel className={classes.wagonNumberStyle}>
                      {wagonTechnicalDetailsState.wagonNumber}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={3}>
                    <FormLabel className={classes.wagonDetail}>
                      {wagonTechnicalDetailsState.keeper !== null &&
                      wagonTechnicalDetailsState.keeper !== ''
                        ? wagonTechnicalDetailsState.keeper
                        : '-'}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={3}>
                    <FormLabel className={classes.wagonDetail}>
                      {wagonTechnicalDetailsState.productType !== null &&
                      wagonTechnicalDetailsState.productType !== ''
                        ? wagonTechnicalDetailsState.productType
                        : '-'}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={3}>
                    <FormLabel
                      className={
                        wagonStatusState === 'available'
                          ? classes.statusStyle
                          : classes.warningStatusStyle
                      }
                    >
                      {t(wagonStatusState)}
                    </FormLabel>
                  </Grid>
                </Grid>
              )}
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Business unit')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Contract number')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Rental start date')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Entity in charge of maintenance')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.businessUnit !== null &&
                    wagonTechnicalDetailsState.businessUnit !== ''
                      ? wagonTechnicalDetailsState.businessUnit
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.contractNumber !== null &&
                    wagonTechnicalDetailsState.contractNumber !== ''
                      ? wagonTechnicalDetailsState.contractNumber
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.rentalStart !== null &&
                    wagonTechnicalDetailsState.rentalStart !== ''
                      ? dateFormatter(wagonTechnicalDetailsState.rentalStart)
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.ecm !== null &&
                    wagonTechnicalDetailsState.ecm !== ''
                      ? wagonTechnicalDetailsState.ecm
                      : '-'}
                  </FormLabel>
                </Grid>
              </Grid>
            </div>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
}
